import type { DealProviderConfig } from '@openx/components-deal/lib/utils/context/DealContext.tsx';
import { useCallback } from 'react';
import { useAuth } from '../../../components/AuthContext/context.ts';

/** OA uses Firebase: force a fresh ID token for downstream API calls. */
export const useRefreshAuthToken: DealProviderConfig['useRefreshAuthToken'] = () => {
  const { currentUser } = useAuth();

  return useCallback(async () => {
    try {
      if (currentUser) {
        await currentUser.getIdToken(true);
      }
    } catch {
      return;
    }
  }, [currentUser]);
};
